export enum CalendarFormat {
  ISO = 'YYYY-MM-DD',
  monthISO = 'YYYY-MM'
}

export enum FirstCallRadioValue {
  All = 'all',
  Single = 'single',
  Range = 'range',
  NonCall = 'nonCall',
  AnytimeCall = 'anytimeCall',
  MakeWholeCall = 'makeWholeCall'
}

export interface FirstCallRadioItem {
  label: FirstCallRadioValue;
  name: string;
  hover?: string;
}

export interface SetFilterMutableOption {
  name: string;
  isPresent: boolean;
}
